
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import Chart from 'chart.js'
import { Line, mixins } from 'vue-chartjs'

@Component({
  extends: Line
})
export default class LineChart extends Mixins(Line, mixins.reactiveProp) {
  @Prop() public chartOptions!: Chart.ChartOptions

  mounted() {
    this.renderChart(this.chartData, this.chartOptions)
  }
}
